import { useEffect } from 'react';
import './HomeInteractionEffects.css';

const MOTION_QUERY = '(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)';

// One passive pointer listener for the page, including cards populated later by CMS.
// The spotlight is decorative, and never turns a non-clickable article into a button.
export function useHomeSpotlights(root) {
  useEffect(() => {
    const media = window.matchMedia(MOTION_QUERY);
    let frame = 0;
    let point;
    const reset = () => root.current?.querySelectorAll('.home-spotlight').forEach(card => card.style.removeProperty('--spot-opacity'));
    const draw = () => {
      frame = 0;
      if (!media.matches || !point) return;
      root.current?.querySelectorAll('.home-spotlight').forEach(card => {
        const rect = card.getBoundingClientRect();
        const x = point.x - rect.left;
        const y = point.y - rect.top;
        const distance = Math.max(-x, x - rect.width, -y, y - rect.height, 0);
        card.style.setProperty('--spot-x', `${x}px`);
        card.style.setProperty('--spot-y', `${y}px`);
        card.style.setProperty('--spot-opacity', String(Math.max(0, 1 - distance / 120)));
      });
    };
    const move = event => {
      if (event.pointerType === 'touch' || !media.matches) return;
      point = { x: event.clientX, y: event.clientY };
      if (!frame) frame = requestAnimationFrame(draw);
    };
    const clear = () => { point = null; reset(); };
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('scroll', clear, { passive: true });
    window.addEventListener('blur', clear);
    document.documentElement.addEventListener('pointerleave', clear);
    media.addEventListener?.('change', clear);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('scroll', clear);
      window.removeEventListener('blur', clear);
      document.documentElement.removeEventListener('pointerleave', clear);
      media.removeEventListener?.('change', clear);
    };
  }, [root]);
}
